import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
} from "@chakra-ui/react";

export interface HelpBreadcrumbProps {
  title: string;
}

export default function Help({ title }: HelpBreadcrumbProps) {
  return (
    <Container
      maxW="5xl"
      pt={{ base: 10, md: 14 }}
      px={14}
      fontSize={{ base: "10px", sm: "12px", md: "16px" }}
    >
      <Breadcrumb>
        <BreadcrumbItem>
          <BreadcrumbLink href="/help">Help Center</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink href="#">{title}</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
    </Container>
  );
}
